'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveAttachmentsForMessage = undefined;

var _fileAttachmentIdsInMessage = require('conversations-schema/pubnub-message/operators/fileAttachmentIdsInMessage');

var _getSessionId = require('../../selectors/widgetDataSelectors/getSessionId');

var _resolveAttachments = require('./resolveAttachments');

var resolveAttachmentsForMessage = exports.resolveAttachmentsForMessage = function resolveAttachmentsForMessage(_ref) {
  var message = _ref.message,
      threadId = _ref.threadId;
  return function (dispatch, getState) {
    var fileIds = (0, _fileAttachmentIdsInMessage.fileAttachmentIdsInMessage)(message);

    if (fileIds.size) {
      var sessionId = (0, _getSessionId.getSessionId)(getState());

      dispatch((0, _resolveAttachments.resolveAttachments)({ fileIds: fileIds, sessionId: sessionId, threadId: threadId }));
    }
  };
};